import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const tooltipComponent = {
  popup: 'tooltip.popup',
} as const satisfies ComponentLocatorMap;
